import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  const getDurationInDays = () => {
    const from = new Date(data.fromDate);
    const to = new Date(data.toDate);
    const timeDiff = to - from;
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  };

  return (
      
    <div className="modal-backdrop">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>✕</button>
        <div className="modal-header">
          <h3>Perfect! Your Dates Are Available</h3>
        </div>
        <div className="modal-content">
          <p>
            We're excited to help you plan your special celebration from{" "}
            <strong>{data.fromDate}</strong> to <strong>{data.toDate}</strong>.
          </p>
          <div className="booking-summary">
            <div className="summary-row">
              <span>Duration:</span>
              <strong>{getDurationInDays()} days</strong>
            </div>
            <div className="summary-row">
              <span>Adults:</span>
              <strong>{data.adults}</strong>
            </div>
            <div className="summary-row">
              <span>Children:</span>
              <strong>{data.children}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
